/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, {useCallback, useEffect, useState} from "react";
import {useValidate} from "../../../../hooks/useValidate";
import useDebounce from "../../../../hooks/useDebounce";
import ModalPortal from "../../../../components-new/ModalPortal";
import sass from "../../StepFour/One/Tables/TableNavigate/DescriptionTable/desc.module.sass";
import InputTemp from "../../../../components-new/InputTemp";
import TextArea from "../../../../components-new/Textarea";
import {Button} from "../../../../components/shared";
import {BUTTON_VARIANTS} from "../../../../components/shared/Button/Button";
import {inapplicabilityReasonsAPI} from "../../../../libs/apiClient/InapplicabilityReasons";
import {useNavigate, useParams} from "react-router-dom";
import {objectsKiiAPI} from "../../../../libs/apiClient/ObjectsKii";
import {OKIIEnumsSimpleResponse, OrganizationObjectThreatResponse} from "../../../../libs/apiClient/data-contracts";
import NewCheckBox from "../../../../components-new/NewCheckBox";
import {snackWrapper} from "../../../../helpers";
import {organizationAPI} from "../../../../libs/apiClient/Organization";

export const ModalCreateTemplate: React.FC<{
  target: { active: boolean; data: null | number; mode: "create" | "select",cb?:()=>void };
  close: () => void;
  step?: 5 | 4;
}> = ({target, close, step = 5}) => {

  const {organizationId} = useParams()
  const navigate = useNavigate()
  /* логика для создания нового шаблона */
  const [pattern, setPattern] = useState({
    name: "",
    comment: "",
  });

  const [objectsOptions, setOpjectsOptions] = useState<OKIIEnumsSimpleResponse[]|OrganizationObjectThreatResponse[]>([])

  const [selectedObjects, setSelectedObjects] = useState<number[]>([])

  const [responseError, setResponseError] = useState(false);

  const changeCreatePattern = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {value, name} = e.target;
    setPattern((prevState) => ({...prevState, [name]: value}));
  };

  const savePattern = () => {
    if (!Array.isArray(target.data)) {
      if (step === 5) {
        inapplicabilityReasonsAPI.categorizationTemplateCreate(
            target.data!,
            pattern
        ).then(() => {
          close()
          navigate(-1)
          snackWrapper('success', 'Шаблон успешно создан')
        })
            .catch((e) => {
              if (e.response.status !== 500) {
                setResponseError(true);
                setTimeout(() => {
                  setResponseError(false);
                }, 2000);
              }
            });
      }else {

      }
    }
  };

  const {error: errorPattern, validate: validatePattern} = useValidate(pattern, ["name"], savePattern);

  /* логика для создания нового шаблона */
  /* логика для применения шаблона */
  const [options, setOptions] = useState<{ id: number; name: string }[]>([]);
  const [checkPattern, setCheckPattern] = useState<{ template_id: number; name: string, comment: string }>({
    template_id: NaN,
    name: "",
    comment: ''
  });

  const [searchOptions, setSearchOptions] = useState("");

  const query = useDebounce(searchOptions, 400);

  const selectPattern = (e: { id: number; name: string, comment: string }) => {
    setCheckPattern({template_id: e.id, name: e.name, comment: e.comment});
  };

  const applyPattern = useCallback(() => {
      if (step === 5) {
          inapplicabilityReasonsAPI.categorizationTemplateApply({objects: selectedObjects}, checkPattern.template_id).then(() => {
              close()
              snackWrapper('success', 'Шаблон успешно применен')
          });
      }else{
          organizationAPI.objectThreatModelTemplateApplyDetail({objects: selectedObjects,templateId:checkPattern.template_id}).then(() => {
              target.cb?.()
              close();
              snackWrapper('success', 'Шаблон успешно применен')
          })
      }
  }, [selectedObjects,step]);

  const {error: errorDownload, validate: validateDownload} = useValidate(checkPattern, ["name"], applyPattern);
  /* логика для применения шаблона */

  useEffect(() => {
    if (target.mode === "select") {
      if (step === 5) {
        inapplicabilityReasonsAPI.categorizationTemplateList()
            .then(({data}) => {
              setOptions(
                  data.reduce((acc: { id: number; name: string, comment: string }[], item) => {
                    const {id, name, comment} = item;
                    acc.push({id, name, comment});
                    return acc;
                  }, []),
              );
            });
        objectsKiiAPI.listDetail(Number(organizationId!)).then((response) => {
          setOpjectsOptions(response.data)
        });
      }else{
        organizationAPI
            .objectThreatModelTemplateListDetail(target.data!, {
              page: 1,
              num: 99999999,
              query,
            })
            .then(({ data }) => {
              setOptions(
                  data.reduce((acc: { id: number; name: string; comment: string }[], item) => {
                    const { id, name,comment } = item;
                    acc.push({ id, name,comment:comment??'' });
                    return acc;
                  }, []),
              );
            });
        organizationAPI.threatsDetail(Number(organizationId!)).then((response) => {
          setOpjectsOptions(response.data)
        });
      }
    } else {
      setOpjectsOptions([])
      setOptions([]);
    }
    return () => {
      setPattern({name: "", comment: ""});
      setCheckPattern({template_id: NaN, name: "", comment: ''});
    };
    //eslint-disable-next-line
  }, [target.active, target.mode, query]);

  return target.active ? (
      <ModalPortal
          title={target.mode === "create" ? "Сохранение шаблона" : "Выберите шаблон МУ"}
          outSide={false}
          handleClose={close}>
        {target.mode === "create" ? (
            <div className={sass.modal_content}>
              <InputTemp
                  error={errorPattern && !pattern.name}
                  errorText={responseError ? "Такое имя уже существует" : ""}
                  value={pattern.name}
                  onChange={changeCreatePattern}
                  name={"name"}
                  required
                  label={"Наименование"}
                  placeholder={"Введите название "}
              />
              <TextArea
                  value={pattern.comment}
                  onChange={changeCreatePattern}
                  name={"comment"}
                  label={"Комментарий"}
                  placeholder={"Введите комментарий "}
              />
            </div>
        ) : (
            <div className={sass.modal_content}>
              <InputTemp
                  error={errorDownload && !checkPattern.name}
                  required
                  value={searchOptions || checkPattern.name || ""}
                  onChange={({target}) => {
                    const {value} = target;
                    setSearchOptions(value);
                  }}
                  onSelect={selectPattern}
                  label={"Шаблон"}
                  placeholder={"Не выбрано"}
                  field={["name"]}
                  options={options}
              />
              {checkPattern.comment &&
                  <div className={sass.comment_block}>
                    <span>Комментарий</span>
                    <span>{checkPattern.comment}</span>
                  </div>
              }
              {checkPattern.name &&
                  <div className={sass.wrapper_objects}>
                    <span>Выберите объекты для применения шаблона</span>
                    <div className={sass.list_objects}>
                      <label className={sass.item}>
                        <NewCheckBox checked={selectedObjects.length === objectsOptions.length} type={"checkbox"}
                                     value={'all'} onChange={() => {
                          if (selectedObjects.length === objectsOptions.length) {
                            setSelectedObjects([]);
                          } else {
                            setSelectedObjects(objectsOptions.map(_ => _.id));
                          }
                        }}/>
                        Выбрать все
                      </label>
                      {objectsOptions.map(option => {
                        return (
                            <label className={sass.item} key={option.id}>
                              <NewCheckBox type={"checkbox"} checked={selectedObjects.includes(option.id)}
                                           value={option.id.toString()} onChange={(e) => {
                                setSelectedObjects((prevState) => {
                                  const copyPrev = [...prevState];
                                  const index = copyPrev.findIndex(idx => idx === Number(e.target.value))
                                  if (index >= 0) {
                                    copyPrev.splice(index, 1);
                                  } else {
                                    copyPrev.push(Number(e.target.value))
                                  }
                                  return copyPrev;
                                })
                              }}/>
                              {'objectName' in option?option.objectName:option.name}
                            </label>
                        )
                      })}
                    </div>

                  </div>

              }
            </div>
        )}
        <div className={sass.btns}>
          <Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
            Отменить
          </Button>
          <Button onClick={target.mode === "create" ? validatePattern : validateDownload}>Готово</Button>
        </div>
      </ModalPortal>
  ) : null;
};
